import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/entity-templates')({
  staticData: { breadcrumb: 'Legal Entity Templates', breadcrumbKey: 'K_BREADCRUMB_ENTITY_TEMPLATES' },
  component: EntityTemplatesLayout,
});

function EntityTemplatesLayout() {
  return <Outlet />;
}
